// extracted by mini-css-extract-plugin
export var container = "_jg-0";
export var segment = "_jg-2";
export var segmentActive = "_jg-3";
export var track = "_jg-1";